var map = {
	"./process01_on.png": "Xstn",
	"./process02_on.png": "TMp+",
	"./process03_on.png": "IZ6h",
	"./process04_on.png": "J6nt",
	"./process05_on.png": "13DU",
	"./process06_on.png": "03p+",
	"./process07_on.png": "IhGf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yotz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image ^\.\/process0.*_on\.png$
// module id = yotz
// module chunks = 1